import { IDenovoIconComponentProps } from "../interfaces";

export const SortDescending = ({
  color = "currentColor",
  width = 24,
  height = 24,
  className,
}: IDenovoIconComponentProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round">
      <line x1="3" y1="6" x2="13" y2="6" />
      <line x1="3" y1="10" x2="11" y2="10" />
      <line x1="3" y1="14" x2="9" y2="14" />
      <line x1="3" y1="18" x2="7" y2="18" />
      <line x1="18" y1="5" x2="18" y2="18" />
      <path d="M15 15.5 18 18.5 21 15.5" />
    </svg>
  );
};
